/**
 * CFTC-required disclaimer for hypothetical performance results.
 *
 * Must appear on any page displaying strategy returns, Sharpe ratios,
 * or other performance metrics.
 *
 * Source: sovrun-web Account.jsx (lines 648-675) — CFTC regulatory boilerplate.
 */
export function PerformanceDisclaimer() {
  return (
    <div className="mt-12 rounded-xl border border-slate-700 bg-slate-800 px-6 py-5 text-xs leading-relaxed text-slate-500">
      <p className="mb-2 font-semibold uppercase tracking-wide text-slate-400">
        Important Disclaimer
      </p>
      <p className="mb-2">
        HYPOTHETICAL PERFORMANCE RESULTS HAVE MANY INHERENT LIMITATIONS, SOME OF WHICH ARE
        DESCRIBED BELOW. NO REPRESENTATION IS BEING MADE THAT ANY ACCOUNT WILL OR IS
        LIKELY TO ACHIEVE PROFITS OR LOSSES SIMILAR TO THOSE SHOWN. IN FACT, THERE ARE
        FREQUENTLY SHARP DIFFERENCES BETWEEN HYPOTHETICAL PERFORMANCE RESULTS AND THE
        ACTUAL RESULTS SUBSEQUENTLY ACHIEVED BY ANY PARTICULAR TRADING PROGRAM.
      </p>
      <p className="mb-2">
        ONE OF THE LIMITATIONS OF HYPOTHETICAL PERFORMANCE RESULTS IS THAT THEY ARE
        GENERALLY PREPARED WITH THE BENEFIT OF HINDSIGHT. IN ADDITION, HYPOTHETICAL
        TRADING DOES NOT INVOLVE FINANCIAL RISK, AND NO HYPOTHETICAL TRADING RECORD CAN
        COMPLETELY ACCOUNT FOR THE IMPACT OF FINANCIAL RISK OF ACTUAL TRADING. FOR
        EXAMPLE, THE ABILITY TO WITHSTAND LOSSES OR TO ADHERE TO A PARTICULAR TRADING
        PROGRAM IN SPITE OF TRADING LOSSES ARE MATERIAL POINTS WHICH CAN ALSO ADVERSELY
        AFFECT ACTUAL TRADING RESULTS. THERE ARE NUMEROUS OTHER FACTORS RELATED TO THE
        MARKETS IN GENERAL OR TO THE IMPLEMENTATION OF ANY SPECIFIC TRADING PROGRAM WHICH
        CANNOT BE FULLY ACCOUNTED FOR IN THE PREPARATION OF HYPOTHETICAL PERFORMANCE
        RESULTS AND ALL WHICH CAN ADVERSELY AFFECT TRADING RESULTS.
      </p>
      <p>
        PAST PERFORMANCE IS NOT NECESSARILY INDICATIVE OF FUTURE RESULTS. THE RISK OF LOSS
        IN TRADING COMMODITY FUTURES, OPTIONS, AND FOREIGN EXCHANGE PRODUCTS CAN BE
        SUBSTANTIAL. YOU SHOULD THEREFORE CAREFULLY CONSIDER WHETHER SUCH TRADING IS
        SUITABLE FOR YOU IN LIGHT OF YOUR FINANCIAL CONDITION.
      </p>
    </div>
  );
}
